export default "/images/08895ec05d9124431de090e42985956f.avif";